const comments = [
  {
    name: '漫画迷小陈',
    text: '漫蛙漫画真的太方便了！更新速度很快，画质也很清晰，每天必刷，强烈推荐给所有喜欢看漫画的朋友。',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cute%20anime%20style%20avatar%20portrait%2C%20young%20person%20with%20warm%20smile%2C%20soft%20lighting%2C%20minimal%20background%2C%20clean%20illustration%20style%2C%20round%20framing&width=120&height=120&seq=avatar-01&orientation=squarish',
  },
  {
    name: '日漫爱好者',
    text: '找了好久才找到这个站，日漫资源很全，很多冷门作品也能找到。界面简洁干净，阅读体验很棒！',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20anime%20style%20avatar%20portrait%20of%20a%20girl%20with%20glasses%2C%20friendly%20expression%2C%20soft%20pastel%20colors%2C%20minimal%20clean%20background%2C%20cute%20illustration%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
  },
  {
    name: '韩漫铁粉',
    text: '韩漫资源太丰富了！每周都有新番更新，完结作品也整理得很好。画风细腻，翻译质量高，已经安利给身边所有朋友。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%2C%20young%20man%20with%20cool%20expression%2C%20simple%20stylish%20look%2C%20soft%20warm%20lighting%2C%20minimal%20background%2C%20clean%20illustration&width=120&height=120&seq=avatar-03&orientation=squarish',
  },
  {
    name: '国漫支持者',
    text: '国漫板块做得很好！很多优秀的国产漫画在这里都能看到。支持国漫崛起，漫蛙漫画网是国漫爱好者的好去处。',
    avatar: 'https://readdy.ai/api/search-image?query=Chibi%20anime%20style%20avatar%2C%20cute%20character%20with%20happy%20expression%2C%20pastel%20pink%20and%20warm%20tones%2C%20minimal%20clean%20background%2C%20adorable%20illustration&width=120&height=120&seq=avatar-04&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">读者心声</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">来自漫蛙漫画读者的真实评价</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((item) => (
            <div
              key={item.name}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="font-heading text-sm font-bold text-foreground-900">{item.name}</h3>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-[10px] text-accent-500"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}